<template>
  <PanelPage ref="useAlerts" :loading-overlay="loadingOverlay">
    <v-card class="mb-6">
      <v-card-title>Create Money Destination</v-card-title>
      <v-form @submit.prevent="submit" @reset="handleReset">
        <v-card-text>
          <v-text-field
            v-model="form.name.value.value"
            :error-messages="form.name.errorMessage.value"
            label="Name of the company"
          />
          <v-text-field
            v-model="form.email_1.value.value"
            :error-messages="form.email_1.errorMessage.value"
            label="Email 1"
          />
          <v-text-field
            v-model="form.email_2.value.value"
            :error-messages="form.email_2.errorMessage.value"
            label="Email 2"
          />
          <v-text-field
            v-model="form.stripe_id.value.value"
            :error-messages="form.stripe_id.errorMessage.value"
            label="Stripe ID"
          />
          <v-text-field
            v-model="form.address_1.value.value"
            :error-messages="form.address_1.errorMessage.value"
            label="Address 1"
          />
          <v-text-field
            v-model="form.address_2.value.value"
            :error-messages="form.address_2.errorMessage.value"
            label="Address 2"
          />
          <v-text-field
            v-model="form.city.value.value"
            :error-messages="form.city.errorMessage.value"
            label="City"
          />
          <v-text-field
            v-model="form.country_a2.value.value"
            :error-messages="form.country_a2.errorMessage.value"
            label="Country"
            hint="IT, FR, BE, NL, ES"
          />
          <v-text-field
            v-model="form.vat_country_a2.value.value"
            :error-messages="form.vat_country_a2.errorMessage.value"
            label="VAT Country"
            hint="IT, FR, BE, NL, ES"
          />
          <v-text-field
            v-model="form.phone_number.value.value"
            :error-messages="form.phone_number.errorMessage.value"
            label="Phone number"
          />
          <v-text-field
            v-model="form.postal_code.value.value"
            :error-messages="form.postal_code.errorMessage.value"
            label="Postal code"
          />
          <v-select
            v-model="form.receipt_language.value.value"
            :error-messages="form.receipt_language.errorMessage.value"
            label="Email report language"
            :items="['FR', 'EN', 'IT']"
          />
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn type="reset">Reset</v-btn>
          <v-btn type="submit">Submit</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </PanelPage>
</template>

<script setup>
import PanelPage from "../components/PanelPage.vue";
import { ref } from "vue";
import { useForm } from 'vee-validate';
import * as yup from 'yup';
import { getFormFromSchema } from "../utils.js";
import { createMoneyDest } from "../remote/moneydest.js";

// State
const useAlerts = ref(null);
const loadingOverlay = ref(false);

// Validation Schema
const schema = yup.object({
  name: yup.string().required(),
  email_1: yup.string().email(),
  email_2: yup.string().email(),
  stripe_id: yup.string().required(),
  address_1: yup.string().required(),
  address_2: yup.string().required(),
  city: yup.string().required(),
  country_a2: yup.string().required().length(2),
  vat_country_a2: yup.string().required().length(2),
  phone_number: yup.string().required(),
  postal_code: yup.string().required(),
  receipt_language: yup.string().required(),
});

const { handleSubmit, handleReset } = useForm({
  validationSchema: schema,
  initialValues: {
    address_1: '-',
    address_2: '-',
    phone_number: '-',
  }
});

const form = getFormFromSchema(schema);

// noinspection JSValidateTypes
const submit = handleSubmit(async (values) => {
  let payload = {
    society_name: values['name'],
    email: values['email_1'] || "",
    email2: values['email_2'] || "",
    stripe_id: values['stripe_id'],
    address_1: values['address_1'],
    address_2: values['address_2'],
    postal_code: values['postal_code'],
    city: values['city'],
    country_alpha2: values['country_a2'].toUpperCase(),
    vat_country_alpha2: values['vat_country_a2'].toUpperCase(),
    phone_number: values['phone_number'],
    receipt_language: values['receipt_language'].toLowerCase(),
  };
  console.log(payload);
  loadingOverlay.value = true;
  // Create MoneyDestination
  try {
    await createMoneyDest(useAlerts, payload);
  } catch (e) {
    useAlerts.value.errorAlert("Error during MoneyDest creation", e.toString());
  } finally {
    loadingOverlay.value = false;
  }
});

</script>

<style scoped>

</style>
